export default __webpack_public_path__ + "static/media/desk-clean3.fea4124a.png";